import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'strToBool'
})
export class StrToBoolPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (args.ValueType === 'checkbox') {
      if (value === '1') {
        return true;
      } else {
        return false;
      }
    }
    return value;
  }

}
